import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ProtectedRoute = ({ children }) => {
  const { user, loading, isSupabaseEnabled } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // If Supabase is not configured, allow access (demo mode)
  if (!isSupabaseEnabled) {
    return children
  }

  // If Supabase is configured, require authentication
  return user ? children : <Navigate to="/login" replace />
}

export default ProtectedRoute